export interface EffAiReviewFinding {
    category: "TestDesign" | "Sampling" | "Evidence" | "Scoring" | "Documentation";
    severity: "High" | "Medium" | "Low";
    title: string;
    detail: string;
    references: string[];
}

export interface EffAiReviewModel {
    reviewId: string;
    summary: string;
    conclusionSupported: "Yes" | "Partially" | "No" | "Unclear";
    findings: EffAiReviewFinding[];
    improvements: string[];
}

// Mirrors TestPlanReviewFeedbackItemType in the backend; the API reads enums as numbers.
export enum EffAiReviewItemType {
    Finding = 0,
    Improvement = 1,
}

// Mirrors TestPlanReviewFeedbackReason in the backend. The numbers are the ids the feedback is counted by, so never
// change or reuse them.
export enum EffAiReviewFeedbackReason {
    Incorrect = 1,
    MissingInformation = 2,
    IrrelevantInformation = 3,
    TooVerbose = 4,
    TooVague = 5,
    WrongFormat = 6,
    DidNotFollowInstructions = 7,
    WrongContext = 8,
    MissingContext = 9,
    WrongSuggestion = 10,
    Other = 11,
}

export interface EffAiReviewFeedbackModel {
    reviewId: string;
    itemType: EffAiReviewItemType;
    itemIndex: number;
    itemText: string;
    relevant: boolean;
    reasons: EffAiReviewFeedbackReason[];
    // The text the user gave with the Other reason.
    comment: string;
}

export interface EffAiReviewCommentsRequestModel {
    reviewId: string;
    findings: EffAiReviewFinding[];
    improvements: string[];
}

// A comment without a testStepGuid is the comment of the sample itself.
export interface EffAiReviewComment {
    sampleGuid: string;
    testStepGuid: string | null;
    comment: string;
}

export interface EffAiReviewCommentsModel {
    comments: EffAiReviewComment[];
    conclusionComment: string;
}
